import { FilterSection } from '@aibees/elephant/feature/search-filters/components/filter-section';
import { useFilterSections } from '@aibees/elephant/feature/search-filters/hooks/use-filter-sections';
import { SearchFilterType } from '@aibees/elephant/feature/search-filters/types';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useMemo } from 'react';
import { ChildrenFilter } from '../../../children-filter';
import type { ButtonGroupFilterItemProps as Props } from './types';

export const ButtonGroupFilterItem = memo(({ className, ...filter }: Props) => {
  const { mainItems, moreItems } = useFilterSections(filter, filter?.sections);

  const { getParam } = useSearchQueryFilter();

  const isAnyOfMoreItemsSet = useMemo(() => {
    return moreItems?.map((i) => getParam(i.field!)).filter(Boolean);
  }, [moreItems]);

  return (
    <Box
      className={classnames('ButtonGroupFilterItem', className)}
      display={'flex'}
      flexDirection={'column'}
      gap={1}
    >
      {filter.type !== SearchFilterType.NONE && (
        <ChildrenFilter open {...filter} />
      )}
      {filter.type === SearchFilterType.NONE &&
        mainItems?.map((item) => {
          return <ChildrenFilter open key={item.field} {...item} />;
        })}
      {filter.type === SearchFilterType.NONE && moreItems?.length ? (
        <FilterSection
          title="More Filters"
          open={!!isAnyOfMoreItemsSet?.length}
        >
          {moreItems?.map((item) => {
            return <ChildrenFilter open key={item.field} {...item} />;
          })}
        </FilterSection>
      ) : null}
    </Box>
  );
});

ButtonGroupFilterItem.displayName = 'ButtonGroupFilterItem';
